import { render, staticRenderFns } from "./contactDoctor.vue?vue&type=template&id=9b986a60&"
import script from "./contactDoctor.vue?vue&type=script&lang=js&"
export * from "./contactDoctor.vue?vue&type=script&lang=js&"
import style0 from "./contactDoctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports